import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home.component';
import { HomeRoutingModule } from './home-routing.module';
import { SharedModule } from '../shared/shared.module';
import { HeadlineComponent } from './headline/headline.component';
import { FeaturesComponent } from './features/features.component';
import { ServicesComponent } from './services/services.component';
import { ServicesV2Component } from './services-v2/services-v2.component';
import { BusinessComponent } from './business/business.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    HomeRoutingModule
  ],
  declarations: [HomeComponent, HeadlineComponent, FeaturesComponent, ServicesComponent, ServicesV2Component, BusinessComponent]
})
export class HomeModule { }
